#import "@/components/common/CraftAssetFragment.gql"

fragment VideoRotationFragment on videoRotation_Entry {
  typeHandle
  heading
  rotationSlides {
    ... on rotationSlidesBlock_Entry {
      preview {
        url
      }
      video {
        ...CraftAssetFragment
      }
      alt
      textOverlay
    }
  }
}
